<template>
    <div>
        <OrderDetails @isConfirmed="goToConfirm" v-if="isConfirmed == false"/>
    </div>
</template>

<script>
    import OrderDetails from "./OrderDetails";
    export default {
        name: "OrderSummary",
        components: {
            OrderDetails
        },
        data() {
            return {
                isConfirmed: false
            }
        }
    }
</script>

<style lang="scss">

    .dark-theme {
        .summary-title {
            color: #EDEEEF;
        }
    }

</style>
